import FetchService from './base.fetch';
// import ConnectService from '../connect';
// import AjaxService from './base.ajax';


/**
 * Iot 数据服务
 * 
 * @export
 * @class IotService
 */
class IotService {

    /**
     * Creates an instance of UserService.
     * @memberof UserService
     */
    constructor() {
        this.domain = FetchService.domainconfig.iot;

        const apisConfig = {
            // codey 向 Iot 服务器注册
            device_register: {
                method: 'post',
                url: 'meos/register',
                headers: this.get_codey_req_header.bind(this),
            },
            // IDE创建云列表
            ide_createcloudlist: {
                method: 'post',
                url: 'ide/createcloudlist',
                auto: true
            },
            // ide 向 Iot 服务器上报云列表数据
            ide_postcloudlist: {
                method: 'post',
                url: 'ide/postcloudlist',
                auto: true
            },
            // ide 从Iot 服务器读取云列表数据
            ide_getcloudlist: {
                method: 'post',
                url: 'ide/getcloudlist?listName=$listName',
                auto: true
            },
            // ide 从 Iot 服务器读取云列表的长度
            ide_getcloudlistlen: {
                method: 'get',
                url: 'ide/getcloudlistlen?listName=:listName',
                auto: true
            },
            // ide 从 Iot 服务器读取云列表的长度
            ide_getcloudlistitembyindex: {
                method: 'get',
                url: 'ide/getCloudListItemByIndex?listName=:listName&type=:type&index=:index',
                auto: true
            },
            ide_getAllCloudListName: {
                method: 'get',
                url: 'ide/getAllCloudListName',
                auto: true
            },
            search_city: {
                domain: FetchService.domainconfig.weather,
                method: 'get',
                forceData: true,
                url: 'weatherSearch?city=:city'
            },
            search_city_air: {
                domain: FetchService.domainconfig.air,
                method: 'post',
                forceData: true,
                url: 'air/search'
            },
            get_city_air_arglist: {
                domain: FetchService.domainconfig.air,
                method: 'post',
                url: 'air/arglist'
            }
        };
        FetchService.configToRequestAction.call(this, apisConfig, FetchService);
    }

    set_codey_req_header(devicetype, deviceid, uid) {
        this.codeyReqHeader = {
            deviceid,
            devicetype,
            uid
        };
    }

    get_codey_req_header() {
        return this.codeyReqHeader;
    }

    get_wifi_list() {
        const channel = window.MbApi.getServiceChannel();
        const request = {
            connectType: 'wlanScan',
            cmd: 'scanning',
            params: {}
        };
        return new Promise((resolve, reject) => {
            if (!channel) {
                return reject('wlan scan service not available');
            }
            channel.sendMessage(request, (err, result) => {
                console.log('wlan scanning...', result);
                if (err) {
                    return reject(err);
                }
                resolve(result);
            });
        });
    }
}

export default new IotService();